// import { useEffect, useState } from "react";
import React, { useEffect, useState } from "react";

import { toast } from "react-toastify";
import swal from "sweetalert";
import { useParams, useNavigate } from "react-router-dom";
import Button from "../../../components/button";
import CardContainer from "../../../components/card_container";
import LoadingModal from "../../../components/loading_modal";
import {
    FiUser,
    FiMail,
    FiPhone,
    FiLock,
    FiBarChart2,
    FiFolder,
    FiPackage,
    FiUsers,
    FiShoppingCart,
    FiSettings,
    FiEdit2,
    FiTrash2,
    FiCalendar,
    FiCheckCircle,
    FiXCircle,
    FiMapPin
} from "react-icons/fi";
import { FaRegIdCard } from "react-icons/fa";
import { EDITUSER } from "../../../routes/routes_name";
import "./detailUserStyle.scss";
import { axios, errorResponse } from "../../../helpers";
import { useSelector } from "react-redux";
import { loginData } from "../../../stores/auth";

const DetailUserPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [administratorData, setAdministratorData] = useState(null);
    const [measuremetData, setMeasurementData] = useState(null);
    const [activeTab, setActiveTab] = useState('info');
    const dataLogin = useSelector(loginData);
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [selectedName, setSelectedName] = useState("");
    const [selectedData, setSelectedData] = useState(null);
    const [selectedMeasurement, setselectedMeasurement] = useState([]);
    const [measurements, setMeasurements] = useState([]);
    const [openRowId, setOpenRowId] = useState(null);


    // const [data, setData] = useState(measurementData);
    const [data, setData] = useState([]);
    const [editModal, setEditModal] = useState(false);
    const [editPayload, setEditPayload] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editForm, setEditForm] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [editName, setEditName] = useState("");
    const [editingId, setEditingId] = useState(null)
    const [formEdit, setFormEdit] = useState({});
    const [selectedDataAddress, setSelectedDataAddress] = useState(null);


    // const [availableValues, setAvailableValues] = useState([]);
    const toggleRow = (id) => {
      setOpenRowId(prev => (prev === id ? null : id));
    };

    const [addresses, setAddresses] = useState([]);
    const [_id, setId] = useState([]);
    const token = dataLogin?.data?.token;

    useEffect(() => {
      if (administratorData?.addresses) {
        setAddresses(administratorData.addresses);
      }
    }, [administratorData]);
    
    useEffect(() => {
      if (administratorData?._id) {
        setId(administratorData._id);
      }
    }, [administratorData]);

    const handleSelectAddress = (id) => {
      setAddresses((prev) => {
        const updated = prev.map((item) => ({
          ...item,
          isActive: item.id === id,
        }));

        const selected = updated.find((item) => item.id === id);
        setSelectedDataAddress(selected);

        return updated;
      });
    };

    const handleChangeEdit = (e) => {
      setFormEdit({
        ...formEdit,
        [e.target.name]: e.target.value,
      });
    };

    // Fetch data
   useEffect(() => {
  if (id && dataLogin?.data?.token) {
    fetchAdministratorData();
  }
}, [id, dataLogin]);

useEffect(() => {
    // console.log("useEffect jalan, id =", id);
    // console.log("token =", dataLogin?.data?.token);
  if (id && dataLogin?.data?.token) {
    fetchmeasurementData();
  }
}, [id, dataLogin]);

 const fetchmeasurementData = async () => {
  try {
    const response = await axios.get(
      `/v1/measurementadmin/users/${id}`,
      {
        headers: {
          Authorization: `Bearer ${dataLogin?.data?.token}`
        }
      }
    );

    const measurements = response?.data?.data || [];
    setMeasurements(response.data.data || []);
 // ⬅️ PISAH STATE
    console.log(measurements,"measure")

  } catch (error) {
    console.error(error);
  }
};



 const fetchAdministratorData = async () => {
  setIsLoading(true);

  try {
    // console.log("Akan request ke:", `/v1/user/user/${id}`);

    const response = await axios.get(`/v1/user/user/${id}`, {
      headers: {
        Authorization: `Bearer ${dataLogin?.data?.token}`
      }
    });

    console.log("FULL RESPONSE:", response);

    const adminData = response?.data?.data;
    console.log("data:", adminData);

    setAdministratorData({
      ...adminData,
      features_access_user: adminData?.features_access_user || {},
    });

  } catch (error) {
    console.error("AXIOS ERROR MASUK SINI 🔥", error);
    console.error("DETAIL:", errorResponse?.(error) ?? error);
  } finally {
    setIsLoading(false);
  }
};
console.log("BASE URL:", axios.defaults.baseURL);
console.log("FULL URL:", axios.defaults.baseURL + `/v1/user/${id}`);

    // const handleUpdateAddress = async () => {
    //     try {
    //         // contoh
    //         // await axios.put(`/address/${selectedAddress._id}`, selectedAddress);

    //         setIsEditOpen(false);
    //     } catch (error) {
    //         console.error(error);
    //     }
    // };


    const handleEdit = () => {
        navigate(EDITUSER, {
            state: {
                ...administratorData,
                _id: administratorData?._id || administratorData?.id || id,
            },
        });
    };

    const handleBack = () => {
        navigate(-1);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('id-ID', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    if (isLoading) {
        return <LoadingModal isLoading={true} />;
    }

    if (!administratorData) {
        return (
            <CardContainer
                title="User Not Found"
                isBack={true}
                children={
                    <div className="not-found-container">
                        <p>User data not found.</p>
                        <Button
                            title="Back to List"
                            onClick={handleBack}
                            variant="outline"
                        />
                    </div>
                }
            />
        );
    }
    // const handleEditAddress = (item) => {
    //     setSelectedAddress(item);
    //     setIsEditOpen(true);
    // };

    const handleEditAddress = (item) => {
      setEditingId(item.id);
      setFormEdit(item);
    };

 const handleNameChange = (name) => {
  setSelectedName(name);
  const found = data.find(item => item.name === name);
  setSelectedData(found || null);
};

const handleEditAllMeasurements = (person) => {
  if (!person) {
    toast.error("Data measurement belum dipilih");
    return;
  }

  setEditName(person.name);

  setEditForm(
    person.measurement.label.map((label, i) => ({
      label,
      value: person.measurement.values[i] || ""
    }))
  );

  setIsEditModalOpen(true);
};



const handleEditChange = (index, value) => {
  const updated = [...editForm];
  updated[index].value = value;
  setEditForm(updated);
};


const handleSaveEdit = () => {
  setData(prev =>
    prev.map(item => {
      if (item.name !== selectedData.name) return item;

      return {
        ...item,
        measurement: {
          label: editForm.map(i => i.label),
          values: editForm.map(i => i.value)
        }
      };
    })
  );

  setIsEditModalOpen(false);
};

const userId = administratorData._id || administratorData?._id || _id;


const handleSaveAddressEdit = async () => {
  try {
    
    if (!editingId) return;

    const address_id = editingId;
    const user_id = administratorData?._id;

    const payload = {
      address_id: address_id,
      address: formEdit.address,
      name: formEdit.name,
    };

    await axios.post(
      `/v1/user/user/${user_id}/address`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const response = await axios.get(
      `/v1/user/user/${user_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setAddresses(response.data.data.addresses); 
    setEditingId(null);
    swal("Success!", "Address has been updated successfully.", "success");
    setIsEditModalOpen(false);

  } catch (error) {
    console.error(error);
    swal(
      "Failed!",
      error.response?.data?.message || "Failed to update address.",
      "error"
    );
  }
};

const handleDeleteAddress = async (address_id) => {
  try {
    if (!address_id) return;

    const confirmed = window.confirm("Yakin hapus alamat ini?");
    if (!confirmed) return;

    const user_id = administratorData?._id;

    await axios.delete(
      `/v1/user/user/${user_id}/address`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: { address_id }, // ⚠️ DELETE pakai body
      }
    );

    setAddresses(prev => prev.filter(addr => addr.id !== address_id));

    swal("Berhasil!", "Alamat berhasil dihapus.", "success");

  } catch (error) {
    console.error(error);

    swal(
      "Gagal!",
      error.response?.data?.message || "Gagal hapus alamat",
      "error"
    );
  }
};

    return (
        <>
            <CardContainer
                title={
                    <div className="detail-header">
                        <div className="header-main">
                            <div className="header-icon-wrapper">
                                <FiUser className="header-icon" />
                            </div>
                            <div>
                                <h1 className="page-title">User Details</h1>
                                <div className="header-subtitle">
                                    <span className="admin-name">{administratorData.name}</span>
                                    <span className={`status-badge ${administratorData.status}`}>
                                        {administratorData.status === 'aktif' ? 'Aktif' : 'Tidak Aktif'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                isBack={true}
                children={(
                    <div className="detail-container" style={{ height: "70vh" }}>
                        {/* Tabs Navigation */}
                        <div className="detail-tabs">
                            <button
                                className={`tab-button ${activeTab === 'info' ? 'active' : ''}`}
                                onClick={() => setActiveTab('info')}
                            >
                                <FaRegIdCard className="tab-icon" />
                                <span>Account Information</span>
                            </button>
                            <button
                                className={`tab-button ${activeTab === 'adress' ? 'active' : ''}`}
                                onClick={() => setActiveTab('adress')}
                            >
                                <FiMapPin className="tab-icon" />
                                <span>Adress</span>
                            </button>
                             <button
                                className={`tab-button ${activeTab === 'measurement' ? 'active' : ''}`}
                                onClick={() => setActiveTab('measurement')}
                            >
                                <FiSettings className="tab-icon" />
                                <span>Measurement</span>
                            </button>
                            {/* <button
                                className={`tab-button ${activeTab === 'activity' ? 'active' : ''}`}
                                onClick={() => setActiveTab('activity')}
                            >
                                <FiCalendar className="tab-icon" />
                                <span>Activity</span>
                            </button> */}
                        </div>

                        {/* Tab Content */}
                        <div className="tab-content">
                            {activeTab === 'info' && (
                                <div className="info-section">
                                    <div className="section-card">
                                        <h3 className="section-title">
                                            <FiUser className="section-icon" />
                                            Personal Information
                                        </h3>
                                        <div className="info-grid">
                                            <div className="info-field">
                                                <label className="field-label">
                                                    <FiUser className="field-icon" />
                                                    Full Name
                                                </label>
                                                <div className="field-value">
                                                    {administratorData.name}
                                                </div>
                                            </div>
                                            <div className="info-field">
                                                <label className="field-label">
                                                    <FiMail className="field-icon" />
                                                    Email Address
                                                </label>
                                                <div className="field-value">
                                                    {administratorData.email}
                                                </div>
                                            </div>
                                            <div className="info-field">
                                                <label className="field-label">
                                                    <FiPhone className="field-icon" />
                                                    Phone Number
                                                </label>
                                                <div className="field-value">
                                                    {administratorData.phone_number}
                                                </div>
                                            </div>
                                            <div className="info-field">
                                                <label className="field-label">
                                                    <FiLock className="field-icon" />
                                                    Account Status
                                                </label>
                                                <div className="field-value">
                                                    <span className={`status-text ${administratorData.status}`}>
                                                        {administratorData.status === 'aktif' ? 'Aktif' : 'Tidak Aktif'}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="section-card">
                                        <h3 className="section-title">
                                            <FiCalendar className="section-icon" />
                                            Account
                                        </h3>
                                        <div className="timeline-grid">
                                            <div className="timeline-item">
                                                <label className="timeline-label">Created At</label>
                                                <div className="timeline-value">
                                                    <FiCalendar className="timeline-icon" />
                                                    {formatDate(administratorData.createdAt)}
                                                </div>
                                            </div>
                                            <div className="timeline-item">
                                                <label className="timeline-label">Last Updated</label>
                                                <div className="timeline-value">
                                                    <FiCalendar className="timeline-icon" />
                                                    {formatDate(administratorData.updatedAt)}
                                                </div>
                                            </div>
                                            {/* <div className="timeline-item">
                                                <label className="timeline-label">Last Login</label>
                                                <div className="timeline-value">
                                                    <FiCalendar className="timeline-icon" />
                                                    {administratorData.last_login ? formatDate(administratorData.last_login) : 'Never logged in'}
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {activeTab === 'adress' && (

                             <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                                {addresses.map((item) => (
                                  <div
                                    key={item.id}
                                    style={{
                                      border: "1px solid #e5e7eb",
                                      borderRadius: "10px",
                                      padding: "16px",
                                      display: "flex",
                                      alignItems: "flex-start",
                                      justifyContent: "space-between",
                                      background: "#fff",
                                    }}
                                  >
                                    {/* Left: Radio */}
                                    <div style={{ marginRight: "12px", paddingTop: "4px" }}>
                                      <input
                                        type="radio"
                                        name="selectedAddress"
                                        checked={item.isActive}
                                        onChange={() => handleSelectAddress(item.id)}
                                      />
                                    </div>

                                    {/* Middle: Content */}
                                    <div style={{ flex: 1 }}>
                                      {/* Nama */}
                                      {editingId === item.id ? (
                                        <input
                                          type="text"
                                          name="name"
                                          value={formEdit.name}
                                          onChange={handleChangeEdit}
                                          className="table-input"
                                          style={{ marginBottom: "8px" }}
                                        />
                                      ) : (
                                        <strong style={{ fontSize: "15px" }}>{item.name}</strong>
                                      )}

                                      {/* Alamat */}
                                      <div style={{ marginTop: "6px" }}>
                                        {editingId === item.id ? (
                                          <textarea
                                            name="address"
                                            value={formEdit.address}
                                            onChange={handleChangeEdit}
                                            className="table-input"
                                            rows={3}
                                            style={{ width: "100%", resize: "vertical" }}
                                          />
                                        ) : (
                                          <>
                                            <div>{item.address}</div>
                                            <small style={{ color: "#6b7280" }}>
                                              {item.city?.name || item.city},{" "}
                                              {item.state?.name || item.state} {item.zipCode}
                                            </small>
                                          </>
                                        )}
                                      </div>

                                    </div>

                                    {/* Right: Action */}
                                    <div
                                      style={{
                                        marginLeft: "16px",
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "8px",
                                      }}
                                    >
                                      {editingId === item.id ? (
                                        <>
                                          <Button
                                            title="Simpan"
                                            className="btn-success btn-sm"
                                            onClick={handleSaveAddressEdit}
                                          />
                                          <Button
                                            title="Batal"
                                            className="btn-outline-secondary btn-sm"
                                            onClick={() => setEditingId(null)}
                                          />
                                        </>
                                      ) : (
                                        <>
                                          <Button
                                            title={<FiEdit2 size={16} />}
                                            className="btn-icon btn-primary btn-sm"
                                            onClick={() => handleEditAddress(item)}
                                          />
                                          <Button
                                            title={<FiTrash2 size={16} />}
                                            className="btn-icon btn-outline-danger btn-sm"
                                            onClick={() => handleDeleteAddress(item.id)}
                                          />
                                        </>
                                      )}
                                      
                                    </div>
                                  </div>
                                ))}
                              </div>    
                            )}

                            
                             {activeTab === 'measurement' && (
                              <div className="adress-section">
                                <div className="section-card">
                                  <h3 className="section-title">
                                    <FiMapPin className="section-icon" />
                                    Measurement
                                  </h3>

                                  <div className="products-table">
                                    <table className="custom-table">
                                      <thead>
                                        <tr>
                                          <th style={{ width: "4%" }}></th>
                                          <th style={{ width: "23%" }}>Name</th>
                                          <th style={{ width: "23%" }}>Umur</th>
                                          <th style={{ width: "23%" }}>Weight / Height</th>
                                          <th style={{ width: "23%" }}>Status</th>
                                          <th style={{ width: "4%%", textAlign: "center" }}>Action</th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {measurements.length === 0 ? (
                                          <tr>
                                            <td colSpan={5} style={{ textAlign: "center" }}>
                                              Tidak ada data measurement
                                            </td>
                                          </tr>
                                        ) : (
                                          measurements.map((item) => {
                                            const isOpen = openRowId === item._id;

                                            return (
                                              <React.Fragment key={item._id}>
                                                {/* MAIN ROW */}
                                                <tr
                                                  className={`accordion-toggle ${
                                                    item.isActive ? "row-active" : "row-inactive"
                                                  }`}
                                                  onClick={() => toggleRow(item._id)}
                                                  style={{ cursor: "pointer" }}
                                                >

                                                  <td>
                                                    {isOpen ? "▼" : "▶"}
                                                  </td>

                                                  <td>{item.label}</td>
                                                  <td>{item.age} tahun</td>
                                                  <td>
                                                    {item.weight} kg / {item.height} cm
                                                  </td>
                                                  <td>{item.isActive ? "Active" : "Inactive"}</td>

                                                  <td className="action-cell" onClick={(e) => e.stopPropagation()}>
                                                    <Button
                                                      title={<FiEdit2 size={16} />}
                                                      className="btn-icon btn-primary btn-sm"
                                                    />
                                                    {/* <Button
                                                      title={<FiTrash2 size={16} />}
                                                      className="btn-icon btn-outline-danger btn-sm"
                                                    /> */}
                                                  </td>
                                                </tr>

                                                {/* COLLAPSED DETAIL ROW */}
                                                {isOpen && (
                                                  <tr className="hiddenRow">
                                                    <td colSpan={5}>
                                                      <div className="collapse-box">
                                                        <table className="inner-table">
                                                          <tbody>
                                                            <tr>
                                                              <td><b>Chest</b></td>
                                                              <td>{item.chest} cm</td>
                                                              <td><b>Waist</b></td>
                                                              <td>{item.waist} cm</td>
                                                            </tr>
                                                            <tr>
                                                              <td><b>Hip</b></td>
                                                              <td>{item.hip} cm</td>
                                                              <td><b>Shoulder Width</b></td>
                                                              <td>{item.shoulderWidth} cm</td>
                                                            </tr>
                                                            <tr>
                                                              <td><b>Neck</b></td>
                                                              <td>{item.neck} cm</td>
                                                              {/* <td><b>Status</b></td>
                                                              <td>{item.isActive ? "Active" : "Inactive"}</td> */}
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                )}
                                              </React.Fragment>
                                            );
                                          })
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            )}
                           

                            {isEditModalOpen && (
                              <div className="modal-overlay">
                                <div className="modal-card">
                                  <div className="modal-row">
                              <label>Nama</label>
                              <input
                                type="text"
                                value={editName}
                                onChange={(e) => setEditName(e.target.value)}
                              />
                            </div>

                                  {editForm.map((item, index) => (
                              <div key={index} className="modal-row">
                                <label>{item.label}</label>
                                <input
                                  type="text"
                                  value={item.value}
                                  onChange={(e) => handleEditChange(index, e.target.value)}
                                />
                              </div>
                                  ))}

                                  <div className="modal-actions">
                                    <Button
                                      title="Cancel"
                                      className="btn-outline-secondary"
                                      onClick={() => setIsEditModalOpen(false)}
                                    />
                                    <Button
                                      title="Save"
                                      className="btn-primary"
                                      onClick={handleSaveEdit}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}


                            {/* {activeTab === 'activity' && (
                                <div className="activity-section">
                                    <div className="section-card">
                                        <h3 className="section-title">
                                            <FiCalendar className="section-icon" />
                                            Recent Activity
                                        </h3>
                                        <div className="activity-list">
                                            <div className="activity-item">
                                                <div className="activity-icon success">
                                                    <FiCheckCircle />
                                                </div>
                                                <div className="activity-content">
                                                    <p className="activity-title">Logged in to system</p>
                                                    <p className="activity-time">Today, 09:15 AM</p>
                                                </div>
                                            </div>
                                            <div className="activity-item">
                                                <div className="activity-icon info">
                                                    <FiEdit2 />
                                                </div>
                                                <div className="activity-content">
                                                    <p className="activity-title">Updated user permissions</p>
                                                    <p className="activity-time">Yesterday, 14:30 PM</p>
                                                </div>
                                            </div>
                                            <div className="activity-item">
                                                <div className="activity-icon warning">
                                                    <FiLock />
                                                </div>
                                                <div className="activity-content">
                                                    <p className="activity-title">Password changed</p>
                                                    <p className="activity-time">3 days ago, 11:20 AM</p>
                                                </div>
                                            </div>
                                            <div className="activity-item">
                                                <div className="activity-icon">
                                                    <FiUser />
                                                </div>
                                                <div className="activity-content">
                                                    <p className="activity-title">Profile information updated</p>
                                                    <p className="activity-time">Jan 20, 2024, 14:45 PM</p>
                                                </div>
                                            </div>
                                            <div className="activity-item">
                                                <div className="activity-icon">
                                                    <FiCalendar />
                                                </div>
                                                <div className="activity-content">
                                                    <p className="activity-title">Account created</p>
                                                    <p className="activity-time">Jan 15, 2024, 10:30 AM</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )} */}
                        </div>

                        {/* Action Buttons */}
                        <div className="detail-actions">
                            <div className="action-buttons">
                                <Button
                                    type="button"
                                    variant="outline"
                                    className="btn-outline-secondary"
                                    title="Back to List"
                                    onClick={handleBack}
                                />
                                <div className="action-group">
                                    <Button
                                        type="button"
                                        variant="primary"
                                        className="btn-primary"
                                        title="Edit"
                                        onClick={handleEdit}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            />
            <LoadingModal isLoading={isLoading} />
        </>
    );
};

export default DetailUserPage;